import { Inject, Injectable } from '@angular/core';
import { EventsStore } from '@boxx/events-core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import {
  catchError,
  map,
  mergeMap,
  switchMap,
  withLatestFrom,
} from 'rxjs/operators';
import { EventModel } from '../models/events.model';
import { EVENTS_SERVICE, IEventsService } from '../services/IEvents.service';
import * as fromActions from './events.actions';

@Injectable()
export class EventsEffects {
  load$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromActions.getEventsBeginAction),
      switchMap(() =>
        this.service.getEvents().pipe(
          map((events: EventModel[]) =>
            fromActions.getEventSuccessAction({ events })
          ),
          catchError((errors) => {
            return of(fromActions.getEventFailAction({ errors }));
          })
        )
      )
    )
  );

  create$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromActions.createEventBeginAction),
      withLatestFrom(this.eventStore.data$),
      switchMap(([action, currentEvents]) =>
        this.service.createEvent(action.payload).pipe(
          mergeMap((event: EventModel) => {
            const payload = [...currentEvents, event].sort((a, b) =>
              a.datetimeFrom.localeCompare(b.datetimeFrom)
            );

            return of([
              fromActions.createEventSuccessAction({
                payload,
                eventId: event.id,
              }),
              fromActions.clearEventsSuccessErrorDataAction(),
            ]).pipe(switchMap((d) => d));
          }),
          catchError((errors) => {
            console.error('Could not Create event');
            return of([
              fromActions.clearEventsSuccessErrorDataAction,
              fromActions.createEventFailAction({ errors }),
            ]).pipe(switchMap((d) => d));
          })
        )
      )
    )
  );

  update$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromActions.updateEventBeginAction),
      switchMap((action) =>
        this.service.updateEvent(action.payload).pipe(
          map((event: EventModel) =>
            fromActions.updateEventSuccessAction({ event })
          ),
          catchError((errors) => {
            console.error('Could not Update event');
            return of(fromActions.updateEventFailAction({ errors }));
          })
        )
      )
    )
  );

  delete$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromActions.EventsActionTypes.deleteEventBegin),
      switchMap((action) =>
        this.service.deleteEvent((action as any).eventId).pipe(
          map((success: boolean) => {
            if (success) {
              return fromActions.deleteEventSuccessAction({
                eventId: (action as any).eventId,
              });
            } else {
              return fromActions.deleteEventFailAction({
                errors: 'Error desconocido',
              });
            }
          }),
          catchError((errors) => {
            console.error('Could not Delete event');
            return of(fromActions.deleteEventFailAction({ errors }));
          })
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    @Inject(EVENTS_SERVICE) private service: IEventsService<EventModel>,
    private eventStore: EventsStore
  ) {}
}
